import styled from '@emotion/styled'
import { calcRem, fonts } from '../../../../__styling'

export const StyledReadersAlsoLoveHeading = styled('h2')(({ theme }) => ({
    fontFamily: fonts.thewest.sansSerifCond,
    fontSize: calcRem(28),
}))
